import cookie from "js-cookie";

export const store = {
  visible: false,
  delay: 3 * 1000,
  duration: 5,
  el: document.getElementById("popup"),
  init() {
    if (window.Shopify?.designMode) {
      this.customizer();
      return;
    }

    this.delay = Number(this.el?.dataset?.delay || 3) * 1000;
    this.duration = Number(this.el?.dataset?.duration || 5);

    if (!cookie.get("popup")) {
      this.shouldOpen();
    }
  },
  customizer() {
    document.addEventListener("shopify:section:select", (event) => {
      const { sectionId } = event.detail;

      if (sectionId.includes("popup")) {
        this.visible = true;
      }
    });

    document.addEventListener("shopify:section:deselect", () => {
      this.visible = false;
    });
  },
  close() {
    this.visible = false;
    cookie.set("popup", "true", {
      path: "/",
      expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * this.duration),
    });
    console.log(cookie.get("popup"));
  },
  open() {
    if (cookie.get("popup")) return;
    this.visible = true;
  },
  shouldOpen() {
    if (cookie.get("popup")) return;
    setTimeout(() => {
      this.open();
    }, this.delay);
  },
};
